import { useEffect, useRef, useState } from "react";
import { Paperclip, Send } from "lucide-react";

const MAX_HEIGHT = 180;

export default function ChatComposer({ onSend, disabled }) {
  const [value, setValue] = useState("");
  const textareaRef = useRef(null);

  // Grow with the text, up to a cap, then scroll inside the box.
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) {
      return;
    }
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, MAX_HEIGHT)}px`;
  }, [value]);

  const submit = () => {
    if (!value.trim() || disabled) {
      return;
    }
    onSend(value);
    setValue("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div className="composer">
      <div className="composer-box">
        <button type="button" className="icon-btn composer-attach" disabled aria-label="پیوست فایل">
          <Paperclip size={18} strokeWidth={1.9} aria-hidden="true" />
        </button>

        <textarea
          ref={textareaRef}
          rows={1}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="پیام خود را بنویسید…"
          aria-label="متن پیام"
        />

        <button
          type="button"
          className="composer-send"
          onClick={submit}
          disabled={disabled || !value.trim()}
          aria-label="ارسال پیام"
        >
          <Send size={18} strokeWidth={2} aria-hidden="true" />
        </button>
      </div>

      <p className="composer-hint">
        برای ارسال <kbd>Enter</kbd> و برای خط جدید <kbd>Shift</kbd> + <kbd>Enter</kbd> را بزنید.
      </p>
    </div>
  );
}
